/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ToDoGroupHeader as ToDoGroupHeaderType } from 'client-code/recordings';

import '../ToDoListContent.scss';

export type ToDoGroupHeaderProps = {
    header: ToDoGroupHeaderType;
};

const ToDoGroupHeader = ({ header }: ToDoGroupHeaderProps) => {
    return (
        <div className="to-do-list-header">
            <div className="to-do-list-row">
                <div className="to-do-row-cell status-icon"></div>
                <div className="to-do-row-cell to-do-list-header-text">{header.name}</div>
            </div>
        </div>
    );
};

export default ToDoGroupHeader;
